import {
  SET_ASSETS,
} from './types';

const initialState = {
  assets: {},
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case SET_ASSETS:
      return { ...state, assets: payload };
    default:
      return state;
  }
};